const { StoryblokBridge } = window;

/* Enter token for project */
const STORYBLOK_TOKEN = "YkDSpnxrre5LFchJQ8AeQQtt";

/* Get locale for endpoint */
const SHOPIFY_LOCALE = Shopify.locale == 'fr' ? '' : `/${Shopify.locale}`

/* Set a parser for templates */
const parser = new DOMParser();

/* Initialize liquidjs */
const liquidEngine = new liquidjs.Liquid();

/**
 * This class parse template in liquid from Storyblok.
 * This class need to be used with html templates tag contained in a #sb-templates script block.
 */
class STBRenderer {
    constructor(accessToken, rendererContainerSelector) {
        this.client = new StoryblokClient({accessToken: STORYBLOK_TOKEN});
        this.templates = parser.parseFromString(document.querySelector('#sb-templates').innerHTML, "text/html");

        this.client.setComponentResolver((component, block) => {
            switch(component) {
                case 'heading':
                    return ` <${block.main_title_level} style="color: ${block.main_title_color.color}" class="${block.main_title_font ? block.main_title_font : '' }">${block.main_title_text}</${block.main_title_level}>`
                    break;
            }
        })

        if(document.querySelector(rendererContainerSelector)) {
            this.container = document.querySelector(rendererContainerSelector)
        } else {
            throw new Error('Render element unknown ('+rendererContainerSelector+')');
        }

        this.registerLiquidTags();
        this.registerLiquidFilters();
    }

    /**
     * Render the component passed in parameter
     * @param component
     * @param appendToContainer
     * @param container
     * @returns {*}
     */
    render(component, appendToContainer = true, container = this.container) {
        // This attribute container the component identifier we use to retrieve correct template
        const componentIdentifier = component.component;

        if ("content" in document.createElement("template")
            && this.templates.querySelector('template#'+componentIdentifier)) {

            // Get template for current component
            const template = this.templates.querySelector('template#'+componentIdentifier);

            // We clone the template into a HTMLString and a DOMElement in order to append STB variables
            const cloneDOM = parser.parseFromString(template.innerHTML, "text/html").body;

            // Add identifier
            const identifier = "block-"+Math.random().toString(36).slice(2);
            cloneDOM.children[0].id = identifier;

            // Get liquid variables
            const liquidVariables = this.getComponentVariables(component);

            console.groupCollapsed('❇️'+componentIdentifier);
            console.log('Available liquid variable', liquidVariables)
            console.groupEnd();

            // Parse our template as a liquid template
            const output = liquidEngine.renderSync(liquidEngine.parse(cloneDOM.outerHTML), liquidVariables);

            if(appendToContainer) {
                container.insertAdjacentHTML('beforeend', output);

                const addedElement = container.querySelector('#'+identifier)
                // Prepare event
                const event = new CustomEvent('cms:block:rendered', {
                    detail: {
                        element: addedElement,
                        identifier: identifier
                    }
                });

                document.dispatchEvent(event);
            } else {
                return output;
            }
        } else {
            console.error('<template/> tag is not available in your browser or '+componentIdentifier+' template has not been found.')
        }
    }

    getComponentVariables(component, exclude = ['content']) {
        const output = {};
        for (const [key, value] of Object.entries(component)) {
            if(!exclude.includes(key)) {
                output[key] = value;
            }
        }
        return output;
    }

    registerLiquidFilters() {
        liquidEngine.registerFilter('rich_text', c => this.renderRichText(c))
        liquidEngine.registerFilter('storyblok_url', (c, sizes) => this.storyblokUrl(c, sizes))
    }

    registerLiquidTags() {
        liquidEngine.registerTag('block', {
            parse: function(token, remainTokens) {
                this.block = token.args;
            },
            render: function(ctx) {
                console.log(ctx);
                const stbRenderer = new STBRenderer(STORYBLOK_TOKEN, '#cms-headless');
                const block = JSON.parse(ctx.scopes[0].sectionObject)
                return stbRenderer.render(block, false);
            }
        });
    }

    renderRichText(content) {
        return this.client.richTextResolver.render(content);
    }

    storyblokUrl(url, sizes) {
        // const imageBase = 'https://img2.storyblok.com/'
        // const imageResource = url.split('https://a.storyblok.com')[1]
        // const newUrl = imageBase + sizes + imageResource
        const imageResource = url
        const newUrl = imageResource + '/m/' + sizes + '/filters:format(webp)'
        return newUrl
    }

    static getSTBQuery() {
        const stbQueries = document.querySelector('[data-stb-queries]');
        return stbQueries !== null ? stbQueries.dataset.stbQueries : false;
    }

    static getSTBEndpoint() {
        const stbEndpoint = document.querySelector('[data-stb-endpoint]');
        return stbEndpoint !== null ? stbEndpoint.dataset.stbEndpoint : false;
    }
}

/**
 * Get Storyblok block for a specified endpoint
 * @param endpoint
 * @param version
 * @returns {Promise<unknown>}
 */
const getBlocks = (endpoint, version = "published") => new Promise(((resolve, reject) => {
    const url = `https://api.storyblok.com/v1/cdn/stories${SHOPIFY_LOCALE}/${endpoint}?token=${STORYBLOK_TOKEN}&version=${version}&time=${Date.now()}`;
    fetch(url)
        .then(response => response.json())
        .then(json => {
            resolve(json.story.content.body)
        });
}));

/**
 * Get storyblok blocks for one query
 * @param query
 * @param version
 * @returns {Promise<*>}
 */
const getBlocksForQuery = async (query, version = "published") => {
    const url = `https://api.storyblok.com/v1/cdn/stories/?token=${STORYBLOK_TOKEN}&version=${version}&time=${Date.now()}&${query}`;
    const response = await (await fetch(url)).json()
    if (response.stories.length !== 0) {
        return response.stories[0].content
    }
}

/**
 * Render multiple blocks from an array of queries
 * @todo need refactor
 * @param queries
 * @param version
 * @returns {Promise<void>}
 */
const getBlocksForMultipleQueries = async (queries, version = "published") => {
    let stbBlocks = []
    for(const query of queries) {
        const response =  await(getBlocksForQuery(query, version))
        // prevent if query return nothing
        if(response) {
            const stbComponents = response.body
            //add stbComponents to an array of object to be able to sort it after
            stbBlocks.push({
                component: stbComponents,
                order: Number(response.complement_produit_position)
            })
        }
    }

    //sort the stbComponents array
    stbBlocks = stbBlocks.sort((a, b) => a.order-b.order );

    const stbRenderer = new STBRenderer(STORYBLOK_TOKEN, '#cms-headless');

    //render the components in the right order
    stbBlocks.map(stpComponents => {
        stpComponents.component.map(stpComponent => {
            stbRenderer.render(stpComponent)
        })
    })

    initFairlyMade()
}

const initSlider = () => {
    const blocksTable = document.querySelectorAll('.section-table')
    if(blocksTable.length) {
        for(let i = 0; i < blocksTable.length; i++) {
            let sliderIndex = 0;
            const columns = blocksTable[i].querySelectorAll('.product-table__column')
            const arrowLeft = blocksTable[i].querySelector('.product-table__arrow--left')
            const arrowRight = blocksTable[i].querySelector('.product-table__arrow--right')

            let sliderIndexMax = columns.length - 1

            arrowLeft.addEventListener('click', () => {
                columns[sliderIndex].classList.remove('product-table__column--active')
                sliderIndex == 0 ? sliderIndex = sliderIndexMax : sliderIndex = sliderIndex - 1
                columns[sliderIndex].classList.add('product-table__column--active')
            })

            arrowRight.addEventListener('click', () => {
                columns[sliderIndex].classList.remove('product-table__column--active')
                sliderIndex == sliderIndexMax ? sliderIndex = 0 : sliderIndex = sliderIndex + 1
                columns[sliderIndex].classList.add('product-table__column--active')
            })
        }
    }
}

const initFairlyMade = () => {
    const fairlyMadeOpeners = document.querySelectorAll('.js-open-fairly-made')
    fairlyMadeOpeners.forEach(fairlyMadeOpener => {
        fairlyMadeOpener.addEventListener('click', () => {
            window.dialog.showModal();
        })
    });
}

const fetchBlocks = (version = "published") => {
    // Check if we need to instantiate Storyblok
    const stbQueries = STBRenderer.getSTBQuery();
    const stbEndpoint = STBRenderer.getSTBEndpoint();
    if(!stbEndpoint && !stbQueries) return null;

    // If we retrieve a Storyblok endpoint, fetch related blocks
    if(stbEndpoint) {
        getBlocks(stbEndpoint, version)
            .then(async stbComponents => {
                const stbRenderer = new STBRenderer(STORYBLOK_TOKEN, '#cms-headless');

                stbComponents.map(stpComponent => {
                    stbRenderer.render(stpComponent)
                })

                initSlider()
                initFairlyMade()
            })
    } else if (stbQueries) {
        //split the dataset to get our four query in an array
        const queries = stbQueries.split(';');
        getBlocksForMultipleQueries(queries, version)
    }
}

document.addEventListener('DOMContentLoaded', async () => {
    // Initialize the Storyblok JS Bridge for preview
    const { StoryblokBridge } = window
    const storyblokInstance = new StoryblokBridge();

    storyblokInstance.pingEditor(() => {
        if (storyblokInstance.isInEditor()) {
            fetchBlocks("draft");
        } else {
            fetchBlocks();
        }
    });

    storyblokInstance.on(['input', 'published', 'change'], (event) => {
        if (event.action === 'input') {
            document.querySelector('#cms-headless').innerHTML = ''

            const stbRenderer = new STBRenderer(STORYBLOK_TOKEN, '#cms-headless');
            event.story.content.body.map(stpComponent => {
                stbRenderer.render(stpComponent)
            })
        } else {
            window.location.reload()
        }
    })
});
